<script setup lang="ts">
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import { Bar } from 'vue-chartjs';
// import type {ChartData, ChartDataset} from 'chart.js'
import { computed, reactive } from 'vue';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
interface dataset {
    data: number[],
    label: string,
    backgroundColor: string,
}
interface Props {
    id: string,
    labels: string[],
    datasets:dataset[]
}

const chartOptions = reactive({
    responsive: true,
    plugins: {
      title: {
        display: false,
        // text: 'Chart.js Bar Chart - Stacked'
      },
    },
    scales: {
        x: {
            grid: {
                display: false
            },
            stacked: true,
        },
        y: {
            title: {
                display: true,
                text: 'Total'
            },
            stacked: true,
            // beginAtZero: false
        }
    }
})

const props = withDefaults(defineProps<Props>(), {labels: ()=> ['label 1', 'label 2', 'label 3', 'label 4'], datasets: ()=> [{data: [1,2,5,2], label: 'data 1', backgroundColor: '#4362A8'}] })

const chartData = computed(()=> { return {labels: props.labels, datasets: props.datasets} })
</script>
    <template>
  <Bar
    :id="id"
    :options="chartOptions"
    :data="chartData"
  />
</template>